import React from "react";
//#region types
import { MasonryPanelProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import Masonry from "react-masonry-css";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const MasonryPanel: React.FC<MasonryPanelProps> = (props) => {
  return (
    <Grid container item>
      <Masonry breakpointCols={props.breakpointCols ?? 2} className={cssExports.masonryGrid}>
        {props.children.map((childElem, index) => (
          <Grid key={index} container item className={cssExports.masonryGridItem}>
            {childElem}
          </Grid>
        ))}
      </Masonry>
    </Grid>
  );
};

export default MasonryPanel;
